'use client';
import { MouseEvent as ReactMouseEvent } from 'react';

import Link from 'next/link';

interface Props {
    href?: string;
    fallbackUrl?: string;
    icon: string;
    text?: string;
    size?: number;
    ariaLabel?: string;
    testId?: string;
}

export default function IconWithLink(props: Props) {
    const onClick = (event: ReactMouseEvent<HTMLAnchorElement>) => {
        if (!props.href || !props.fallbackUrl) {
            return;
        }
        event.preventDefault();

        const link = props.href;
        const linkEl = document.createElement('a');
        linkEl.href = link;

        window.location.href = link;

        setTimeout(() => {
            if (!document.hasFocus()) {
                return;
            } else {
                window.location.href = props.fallbackUrl!;
            }
        }, 500);
    };

    return (
        props.href && (
            <Link
                data-testid={props.testId}
                aria-label={props.ariaLabel}
                onClick={onClick}
                className={`flex cursor-pointer gap-x-2`}
                href={props.href}
                rel="nofollow"
                target={props.fallbackUrl ? '_self' : '_blank'}
            >
                <span className={`icon h-${props.size ?? '4'} w-${props.size ?? '4'} md:h-6 md:w-6 ${props.icon}`} />
                {props.text && <span className="md:text-regular text-sm">{props.text}</span>}
            </Link>
        )
    );
}
